// Helper functions
logFuncCall = function(func_name) {
    console.log("%cFunction",'color:red;',func_name+"()");
}
logFuncCallArgs = function(arg) {
    console.log("%Args\t",'color:blue;',arg);
}
logEvntCall = function(evt_name) {
    console.log("%cEvent\t",'color:orange;',evt_name);
}

function GetURLParameter(sParam) {

  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');

  for (var i = 0; i < sURLVariables.length; i++)
  {

    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam)
    {
      return sParameterName[1];
    }

  }

}

function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length,c.length));
  }
  return null;
}

function deserialize(str) {

  return (str).replace(/(^\?)/, '').split("&").map(function(n) {
    return n = n.split("="), this[n[0]] = n[1], this
  }.bind({}))[0];

}

function getDomain( url ) {
  return url.replace(/https?:/,"");
}

function redirect_browser_to ( url ) {
  	if ( debug ) {
 		logFuncCall("redirect_browser_to");
      	logFuncCallArgs(url);
    }
  	else {
  		// 2019-8-14 top.location.href = url;
      	top.location.assign( url );
    }
}

function host ( url ) {
 
	// this function returns the url in the format subdomain.domain.tld
  	// In our case, we do things slightly differently..
  	//	- we skip the checking for anything but .com in the regex
  	//  - we make sure the domains can't be anything but the country subdomains or www
  
  	var regxHostname = /(au|nz|uk|www).\S*\.\S{1,3}/;
  	
  	return regxHostname.exec( url )[0];
}

window.geoIpApp = {
  cookies: {
    geoip: function(){ return readCookie('geoip') },									// Serialized JSON
    redirect: readCookie('redirect'),							// URL of preferred location (Override) or 0 (false)
    hasGeoIpCookie: Boolean( readCookie('geoip') ),
    hasRedirectCookie: Boolean( readCookie('redirect') ),		// Returns true if value is "0" or "https://nz.hotmilklingerie.com/", else null is false
    overrideIsOn: function() { return readCookie('redirect') == false }
  },
  settings: {
   	enableApp: true,
    enableAutoRedirect: true,
    enableManualOverride: true,
    saveUserLocationPreferenceInCookie: true,
  	saveUserGeoIpData: true,
    cookies: { expires: 3, path: '/' },
  	preferredLocations: window.preferedLocationsFromSettings,
  	debug_mode: false
  },
  ajaxAsync: false,
  countryCodeBasedOnCurrentStoreURL: (function getStoreWeAreCurrentlyOn () {
  	var ctry = null;
    if ( location.hostname.search(".co.nz") == 0 )
      ctry = "NZ";
    if ( location.hostname.search(".com.au") == 0 )
      ctry = "AU";
    if ( location.hostname.search(".co.uk") == 0 )
      ctry = "UK";
    if ( location.hostname.search(".com") == 0 )
      ctry = "US";

    return ctry;  
  }()),
  getPreferredLocations: function () {
    return window.geoIpApp.settings.preferredLocations;
  },
  getRedirectURLHostfrmCntyCode: function ( ctry_code ) {
    
    var preferredLocations = window.geoIpApp.getPreferredLocations();
    
    if ( ctry_code == "US" )
    {
      redirectURL = preferredLocations._default;	 
    }
    else {
      redirectURL = preferredLocations.redirects[ ctry_code ] ;
    }
    
    if ( debug ) {
    	logFuncCall("getRedirectURLHostfrmCntyCode")
        console.log("returns: " + host ( redirectURL ) );
    }
    
    return host ( redirectURL );
    
  },
  loadManualOverrideCntryDropDwn: function () {
    
    if( debug )
      logFuncCall("loadManualOverrideCntryDropDwn");
    
  	$('select#store_country_picker').on('change', function(e){
	
      if( debug )
      	logEvntCall('onStoreCountryPickerChange');
      
      var selectedLocation = "",
          redirectURL = null,
          preferredLocations = window.geoIpApp.getPreferredLocations();

      selectedLocation = $(e.target).val();
      overrideKeyValue = "/?override=1";
      
      if( debug ) {
       	 console.log("selectedLocation", selectedLocation);
         console.log("window.geoIpApp.countryCodeBasedOnCurrentStoreURL", window.geoIpApp.countryCodeBasedOnCurrentStoreURL);
      }

      if ( selectedLocation != window.geoIpApp.countryCodeBasedOnCurrentStoreURL ){

        redirectURL = "//" + window.geoIpApp.getRedirectURLHostfrmCntyCode( selectedLocation ) + overrideKeyValue;
		
        console.log("selectedLocation: " + selectedLocation);
        console.log("redirectURL: " + redirectURL);
        
        

        // Redirect
        redirect_browser_to( redirectURL  );
      }

  	});
    
  },
  requestGeoLocationAJAX: function ( callback ) {
    var oReq = new XMLHttpRequest();
    oReq.addEventListener("load", callback );
    /* MASHAPE VERSION */
    /*
    oReq.open("GET", "https://telize-v1.p.mashape.com/geoip", window.geoIpApp.ajaxAsync );
    oReq.setRequestHeader('X-Mashape-Key','7bPtSkJYtCmshNSGgchqh1MVnLXOp1K31hvjsn4xoVY9OgkxvN');
    oReq.setRequestHeader('Accept','application/json');
    */
    oReq.open("GET", "https://telize-v1.p.rapidapi.com/geoip", window.geoIpApp.ajaxAsync );
    oReq.setRequestHeader('x-rapidapi-host','telize-v1.p.rapidapi.com');
    oReq.setRequestHeader('x-rapidapi-key','a61f2d6aebmshea26202d6f1737ep194d13jsn41d1bf7648bc');
    
    oReq.send();
  },
  redirectCustomerToCorrectStore: function ( geoip ) {
    
      if(debug)
	      logFuncCall("redirectCustomerToCorrectStore");
    
      var preferredLocations = window.geoIpApp.getPreferredLocations(),
          ctryCode3 = geoip.country_code3,
          url_redirect = preferredLocations.redirects[ geoip.country_code3 ] || preferredLocations.redirects[ geoip.country_code ],	// Load best location based on country code
          cookie_expiration_days = window.geoIpApp.settings.cookies.expires

      if ( url_redirect == undefined ){
          // If we have no matching URL for the country code, we go to the default site
          url_redirect = preferredLocations._default;
      }

      if ( debug )
          console.log("Best Store for this customer:", host ( url_redirect ));
		
      // Loop prevention..
      if ( location.host != host ( url_redirect ) )
      {
      	redirect_url = "//" + host ( url_redirect ) + window.geoIpApp.getOriginalDirection();
        
        if(debug) {
          	console.log("Normally, we would be redirected to: " + redirect_url );
        }
        else {
        	//redirect_browser_to( redirect_url );
        }
      }
    
  },
  getGeoIpCookie: function () {
    
    return window.geoIpApp.cookies.geoip().charAt(0) == "{" 
      	? JSON.parse( window.geoIpApp.cookies.geoip() ) 
      	: deserialize( window.geoIpApp.cookies.geoip() );
    
  },
  currentLocationIsPreferred: function() {
  	var preferredLocations = window.geoIpApp.getPreferredLocations(),
        geoip = window.geoIpApp.getGeoIpCookie(),
        ctryCode3 = geoip.country_code3,
        url_redirect = preferredLocations.redirects[ geoip.country_code3 ] || preferredLocations.redirects[ geoip.country_code ];	// Load best location based on country code
        
   	if ( url_redirect == undefined ){
    	// If we have no matching URL for the country code, we go to the default site
        url_redirect = preferredLocations._default;
    }
    
    return url_redirect == location.hostname;
  },
  getOriginalDirection: function() {
  	return location.pathname + location.search;
  },
  events: {
    onDOMContentLoaded: function( e ) {
    	window.geoIpApp.loadManualOverrideCntryDropDwn( e );
    },
    onGeoLocationAjaxResponse: function ( xmlHttpResponse ) {
	
      if ( debug )
        logEvntCall("onGeoLocationAjaxResponse")
      
      var geoip = JSON.parse( xmlHttpResponse.target.response );

      if ( window.geoIpApp.settings.saveUserGeoIpData && ! debug )
      {
        createCookie( "geoip", JSON.stringify( geoip ) )
      }

      if ( window.geoIpApp.settings.enableManualOverride && ! window.geoIpApp.cookies.overrideIsOn() )
      {
      	// Fires only if manual override is enabled but not found as a cookie
        if (debug) 
          console.log("Calling Redirect Customer To Correct Store Function from within 'onGeoLocationAjaxResponse'");
        
        window.geoIpApp.redirectCustomerToCorrectStore( geoip );
      }
      
      // DOES NOT SEEM TO BE USED...
      // $(window).trigger("GeoLocationAjaxResponseEnded");

    }
  }
};

function showDebugInfoInConsole() {

  console.log("Geoip Feature is ON and started...");
  //console.log("%cDebug Mode","font-weight:bold; color: red");
  
  // OUTPUT DEBUG DETAILS ABOUT SETTINGS...
  console.groupCollapsed('Geoip Feature Settings');
  console.log("Enabled Auto-Redirect?", true);
  console.log("Enabled Manual Override?", window.geoIpApp.settings.enableManualOverride );
  console.log("Save Geo-Location data on users browser upon first visit?", window.geoIpApp.settings.saveUserGeoIpData ? "Yes" : "No" );
  console.log("Remember the user's preference to redirect or not to redirect?", window.geoIpApp.settings.saveUserLocationPreferenceInCookie ? "Yes" : "No");
  console.log("Cookie expiration days?", 3 );
  console.log("Default redirect location", "www.hotmilklingerie.com.au" );
  console.groupEnd();

  // OUTPUT DEBUG DETAILS ABOUT VARIABLES USED IN THE SCRIPT...
  console.groupCollapsed('Geoip Feature Status');
  console.log("ajaxAsync:", window.geoIpApp.ajaxAsync);
  console.log("Cookie geoip exists?", window.geoIpApp.cookies.hasGeoIpCookie ? "Yes" : "No" );
  console.log("Cookie redirect exists?", window.geoIpApp.cookies.hasRedirectCookie ? "Yes" : "No" );
  console.log("Is cookie override on?", window.geoIpApp.cookies.overrideIsOn() ? "Yes" : "No" );
  console.log("What's the value inside the Redirect Cookie?", window.geoIpApp.cookies.redirect );
  //console.log("Prefered Location for this store:", getPreferredLocations().redirects[window.geoip.country_code3] || getPreferredLocations().redirects[window.geoip.country_code]);
  console.log("Country code for the store the customer is currently on right now:", window.geoIpApp.countryCodeBasedOnCurrentStoreURL );
  console.groupEnd();
  
}

var geoIpAppSetngs = window.geoIpApp.settings,
    geoIpAppCookies = window.geoIpApp.cookies,
	debug = window.geoIpApp.settings.debug_mode;

if ( debug )
  
	showDebugInfoInConsole();

if ( geoIpAppSetngs.enableApp )
{
  	// App Is Enabled..
  
	if ( geoIpAppSetngs.enableManualOverride )
    {
      	
      	/* If manual override is enabled..
    
    	- Check for the presence of the Override url parameter and if = 1, save this state as a cookie called "redirect" = 0
    	- Check if its already saved in the redirect cookie. 0 = no redirection      

        */
      
      	if ( GetURLParameter('override') == 1 ) 
        {
        	
          // Override found in URL...
          
          if ( debug )
          	console.log("- Override is present in the URL. We are not redirecting and saving 0 inside the redirect cookie....");
          
          // Manual Override. Simple - we save the current url bc that's why they're here ;)
          var expires = window.geoIpApp.settings.cookies.expires;
		
          createCookie( 'redirect', 0, expires );
          
        }
      	
      	// Load the Drop-down
      	(document.addEvent || document.addEventListener)("DOMContentLoaded", window.geoIpApp.events.onDOMContentLoaded );

    }
  
  	if ( geoIpAppSetngs.enableAutoRedirect && ! window.geoIpApp.cookies.overrideIsOn()  )
    {
     
      	// HERE:
      	// Auto Redirect is ON
      	// Override is OFF
      
      	// 1. Get GeoIp details...
    	if ( ! geoIpAppCookies.hasGeoIpCookie && geoIpAppSetngs.saveUserGeoIpData )
        {
          	window.geoIpApp.requestGeoLocationAJAX( window.geoIpApp.events.onGeoLocationAjaxResponse );
        }
      
      	
      	if ( geoIpAppCookies.hasGeoIpCookie && ! geoIpAppCookies.overrideIsOn() )
        {

            // We have the geo location data stored in the geoIp cookie..
          
          	if ( debug )
              	console.log("Calling Redirect Customer To Correct Store Function from 'Auto-redirect' section");
            
            window.geoIpApp.redirectCustomerToCorrectStore( window.geoIpApp.getGeoIpCookie() );

        }
      
    }
  
}
